// src/components/CheckboxGroup.js
import React from 'react';

const CheckboxGroup = ({ title, options, selected, onChange }) => {
    const handleSelect = (option) => {
        const newSelected = selected.includes(option)
            ? selected.filter(item => item !== option)
            : [...selected, option];
        onChange(newSelected);
    };

    return (
        <div className="form-group">
            <label className="form-label">{title}</label>
            <div className="toggle-group-grid">
                {options.map(option => {
                    const uniqueId = `toggle-${title.replace(/\s+/g, '-')}-${option}`;
                    return (
                        <label htmlFor={uniqueId} key={option} className="toggle-group-item">
                            <span>{option}</span>
                            <div className="toggle-switch">
                                <input
                                    id={uniqueId}
                                    type="checkbox"
                                    checked={selected.includes(option)}
                                    onChange={() => handleSelect(option)}
                                />
                                <span className="slider"></span>
                            </div>
                        </label>
                    );
                })}
            </div>
        </div>
    );
};

export default CheckboxGroup;